export enum ConditionWebKind {
    IS_AUTHENTICATE = 0
}
